export const logoStyle = {
  animationDuration: '.3s',
  animationName: 'appear',
}

export const setBackgroundColor = color => ({
  backgroundColor: color,
})

export const setBorderColor = color => ({
  borderColor: color,
})

export const styleByScreenSize = width => ({
  width: width > 0 ? `${width - 10}px` : '360px',
  margin: width > 0 ? '5px 5px 20px' : '15px 10px 20px 10px',
})
